import he from "he"

export const Starters = ({starters, handleButtonClick}) => {
    return <div className="list-group">
            {starters.map((q, i) => (
            <div
                key={i}
                className="list-group-item list-group-item-action small"
                style={{cursor: "pointer", maxWidth:"40%", fontSize:"14px"}}
                onClick={() => handleButtonClick(q)}
            >{he.decode(q)}
            </div>
            ))}
       </div>
};